<template>
  <div>
    <div class="margin-top margin-left">
      <el-button size="mini" @click="send()">新建短信</el-button>
      <el-button size="mini" @click="sendById()">发送</el-button>
      <el-button size="mini" @click="deleteSms()">删除</el-button>
      <el-button size="mini" @click="getList(1)">已发送</el-button>
      <el-button size="mini" @click="getList(0)">草稿箱</el-button>
      <el-button size="mini" @click="getList(2)">发送失败</el-button>
    </div>
    <el-descriptions
      class="margin-top margin-left"
      :column="2"
      size="mini"
      border
    >
      <el-descriptions-item label="客户名称">
        <el-input
          v-model="data.customerName"
          size="mini"
          placeholder="请输入"
          style="width: 250px"
        />
      </el-descriptions-item>
      <el-descriptions-item label="发送时间">
        <el-date-picker
          v-model="sendStartDate"
          size="mini"
          type="date"
          format="yyyy-MM-dd"
          placeholder="选择日期"
          value-format="timestamp"
        >
        </el-date-picker>
        至
        <el-date-picker
          v-model="sendEndDate"
          size="mini"
          type="date"
          format="yyyy-MM-dd"
          placeholder="选择日期"
          value-format="timestamp"
        >
        </el-date-picker>
      </el-descriptions-item>
      <el-descriptions-item label="发送号码">
        <el-input
          v-model="data.phone"
          size="mini"
          placeholder="请输入"
          style="width: 250px"
        />
      </el-descriptions-item>
      <el-descriptions-item label="发送模版">
        <el-select
          v-model="data.templateId"
          placeholder="请选择"
          clearable
          size="mini"
          filterable
        >
          <el-option
            v-for="item in templateList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </el-descriptions-item>
      <el-descriptions-item label="操作员">
        <user-select @on-select="onUserSelect" @clear="clearUserSelect" />
      </el-descriptions-item>
    </el-descriptions>
    <el-table
      class="margin-top margin-left"
      max-height="600px"
      :data="smsList"
      border
      v-loading="loading"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column label="发送号码" prop="phone" width="120" />
      <el-table-column label="名称" prop="name" width="100" />
      <el-table-column label="消息内容" prop="message_content" />
      <el-table-column label="内容长度" width="100">
        <template slot-scope="data">
          {{ data.row.message_content.length }}
        </template>
      </el-table-column>
      <el-table-column label="短信条数" width="100">
        <template slot-scope="data">
          {{ calcSendNum(data.row.message_content) }}
        </template>
      </el-table-column>
      <el-table-column label="发送时间" prop="send_at" width="150" />
      <el-table-column label="操作人" prop="admin_name" width="100" />
      <el-table-column label="操作" width="120">
        <template slot-scope="data">
          <el-link
            type="primary"
            :underline="false"
            v-if="data.row.status == 0"
            icon="el-icon-delete"
            @click="deleteSms(data.row.id)"
          >
            删除
          </el-link>
          <el-link
            type="primary"
            :underline="false"
            v-if="data.row.status != 1"
            icon="el-icon-s-promotion"
            @click="sendById(data.row.id)"
          >
            发送
          </el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="sizes, total, prev, pager, next"
      :total="totalCount"
      :current-page.sync="data.page"
      :page-size.sync="data.pageSize"
      :page-sizes="[10, 20, 50, 100]"
      class="margin-top"
      style="float: right"
    />
    <sms-send :visable.sync="sendVisable" @close="closeSend" />
  </div>
</template>

<script>
import userSelect from "@/components/common/userSelect.vue";
import SmsSend from "@/components/Admin/Butler/SmsSend";
export default {
  name: "Sms",
  components: { userSelect, SmsSend },
  data() {
    return {
      data: {
        customerName: "",
        sendStartDate: "",
        sendEndDate: "",
        phone: "",
        templateId: "",
        adminIds: [],
        page: 1,
        pageSize: 10,
      },
      sendStartDate: "",
      endStartDate: "",
      templateList: [],
      sendVisable: false,
      smsList: [],
      totalCount: 0,
      loading: false,
      status: 1,
      ids: [],
    };
  },
  mounted() {
    this.getTemplateList();
  },
  watch: {
    "data.page"(n, o) {
      this.getList();
    },
    "data.pageSize"(n, o) {
      this.getList();
    },
  },
  methods: {
    getTemplateList() {
      this.$myhttp
        .post(
          "admin/SmsTemplate/getTemplateList",
          { page: 1, pageSize: 100 },
          {
            "Content-Type": "application/x-www-form-urlencoded",
          }
        )
        .then((res) => {
          // 异步执行成功后
          this.templateList = res.data.data;
        });
    },
    onUserSelect(data) {
      this.data.adminIds = data.map((item) => {
        return item.id;
      });
    },
    clearUserSelect() {
      this.data.adminIds = [];
    },
    send() {
      this.sendVisable = true;
    },
    closeSend() {
      this.sendVisable = false;
    },
    getList(status) {
      this.loading = true;
      this.ids = [];
      this.data.sendStartDate = this.sendStartDate / 1000;
      this.data.sendEndDate = this.sendEndDate / 1000;
      if (status >= 0) {
        this.status = status;
      }
      this.data.status = this.status;
      this.$myhttp
        .post("admin/Sms/smsList", this.data, {
          "Content-Type": "application/x-www-form-urlencoded",
        })
        .then((res) => {
          // 异步执行成功后
          if (res.data.code == 200) {
            this.smsList = res.data.data;
            this.totalCount = res.data.totalCount;
          }
        });
      this.loading = false;
    },
    calcSendNum(str) {
      if (str.length <= 64) {
        return 1;
      } else if (str.length > 64 && str.length <= 131) {
        return 2;
      } else if (str.length > 131) {
        const num = Math.ceil((str.length - 131) / 67);
        return num + 2;
      }
    },
    handleSelectionChange(data) {
      let ids = data.map((item) => {
        return item.id;
      });
      this.ids = ids;
    },
    sendById(id) {
      let ids = [];
      if (id !== undefined) {
        ids = [id];
      } else {
        ids = this.ids;
      }
      if (ids.length == 0) {
        this.$message.error("请选择发送的短信");
        return;
      }
      this.$myhttp
        .post(
          "admin/Sms/sendSmsById",
          { ids },
          {
            "Content-Type": "application/x-www-form-urlencoded",
          }
        )
        .then((res) => {
          // 异步执行成功后
          if (res.data.code == 200) {
            this.$message.success(res.data.msg);
            this.getList();
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
    deleteSms(id) {
      let ids = [];
      if (id !== undefined) {
        ids = [id];
      } else {
        ids = this.ids;
      }
      if (ids.length == 0) {
        this.$message.error("请选择发送的短信");
        return;
      }
      this.$myhttp
        .post(
          "admin/Sms/deleteSms",
          { ids },
          {
            "Content-Type": "application/x-www-form-urlencoded",
          }
        )
        .then((res) => {
          // 异步执行成功后
          if (res.data.code == 200) {
            this.$message.success(res.data.msg);
            this.getList();
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
  },
};
</script>

<style>
.margin-top {
  margin-top: 10px;
}
.margin-left {
  margin-left: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/Admin/Butler/Sms.vue